import { BillingPage } from "./billing";

export const Billing = BillingPage;
